
const Title = ({title}) => {
  return (
    <div className='section-title'>
      <h4>{title}</h4>
      <span className='line'></span>
    </div>
  )
}

export default Title